import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { ReservaDataService } from '../../../services/reserva-data.service';
import { PNaturalService } from '../../../services/p-natural.service';
import { PJuridicaService } from '../../../services/p-juridica.service';
import { NzTableComponent, NzThMeasureDirective } from 'ng-zorro-antd/table';
import { NzTabComponent, NzTabSetComponent } from 'ng-zorro-antd/tabs';
import { FormsModule } from '@angular/forms';
import { NzInputDirective } from 'ng-zorro-antd/input';
import { NgForOf, NgIf } from '@angular/common';

@Component({
  selector: 'app-step-1',
  templateUrl: './step-1.component.html',
  styleUrls: ['./step-1.component.css'],
  imports: [
    NzTableComponent,
    NzTabComponent,
    NzTabSetComponent,
    FormsModule,
    NzInputDirective,
    NzThMeasureDirective,
    NgForOf,
    NgIf
  ]
})
export class Step1Component implements OnInit {
  personasNaturales: any[] = [];
  personasJuridicas: any[] = [];
  personasNaturalesOriginal: any[] = [];
  personasJuridicasOriginal: any[] = [];
  personaSeleccionada: any = null;
  searchNatural: string = '';
  searchJuridical: string = '';

  @Output() personaSeleccionadaEvent = new EventEmitter<any>(); // Emisor de evento

  constructor(private reservaDataService: ReservaDataService, private personaNaturalService: PNaturalService, private personaJuridicaService: PJuridicaService) {}

  ngOnInit(): void {
    this.loadPersonasNaturales();
    this.loadPersonasJuridicas();
  }

  loadPersonasNaturales(): void {
    this.personaNaturalService.getCiudadanos().subscribe((data) => {
      this.personasNaturales = data;
      this.personasNaturalesOriginal = [...data];
    });
  }

  loadPersonasJuridicas(): void {
    this.personaJuridicaService.getOrganizaciones().subscribe((data) => {
      this.personasJuridicas = data;
      this.personasJuridicasOriginal = [...data];
    });
  }

  buscarPersonaJuridica(): void {
    const searchValue = this.searchJuridical.trim().toLowerCase();
    if (searchValue === '') {
      this.personasJuridicas = [...this.personasJuridicasOriginal];
    } else {
      this.personasJuridicas = this.personasJuridicasOriginal.filter((p) =>
        (p.razon_social?.toLowerCase() || '').includes(searchValue) ||
        (p.ruc || '').includes(searchValue)
      );
    }
  }

  seleccionarPersona(persona: any): void {
    if (persona.id_persona_natural) {
      this.personaSeleccionada = { id_persona_natural: persona.id_persona_natural };
      this.reservaDataService.setData('personaSeleccionada', this.personaSeleccionada);
      this.personaSeleccionadaEvent.emit(this.personaSeleccionada);
    } else if (persona.id_persona_juridica) {
      this.personaJuridicaService.getOrganizacionById(persona.id_persona_juridica).subscribe((data) => {
        this.personaSeleccionada = {
          id_persona_juridica: persona.id_persona_juridica,
          id_tipo_institucion: persona.tipo_institucion.id_tipo_institucion
        };
        this.reservaDataService.setData('personaSeleccionada', this.personaSeleccionada);
        this.personaSeleccionadaEvent.emit(this.personaSeleccionada);
      });
    }
  }
}
